import React from "react";
import { Container, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBrand } from "../brand/BrandContext";
import { resolveBrandContacts } from "../brand/contacts";
import TenantLegalNotice from "../components/TenantLegalNotice";
import LegalPageBody from "../components/LegalPageBody";

const PrivacyPolicy = () => {
  const { t } = useTranslation("common");
  const brand = useBrand();
  const contacts = resolveBrandContacts(brand);
  const supportEmail = contacts.email || brand.supportEmail || "support@sv-city.com.ua";

  const defaultBody = (
    <>
      <Typography variant="body2" color="textSecondary" gutterBottom textAlign="center">
        {t("privacyPolicy.lastUpdated")}
      </Typography>

      <Box mt={5}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s1Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s1P1")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s2Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s2P1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s2P2")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s3Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3P1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3L1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3L2")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3L3")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3L4")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s3L5")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s4Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s4P1")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s5Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5P1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5L1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5L2")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5L3")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5L4")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s5L5")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s6Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s6P1")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s7Title")}</Typography>
        <Typography paragraph>
          {t("privacyPolicy.s7P1Before")}<strong>LiqPay</strong>{t("privacyPolicy.s7P1After")}
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s8Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s8P1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s8L1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s8L2")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s8P2")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s9Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s9P1")}</Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s10Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s10P1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s10L1")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s10L2")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s10L3")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s10L4")}</Typography>
        <Typography paragraph>
          {t("privacyPolicy.s10P2")}<a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>{t("privacyPolicy.s11Title")}</Typography>
        <Typography paragraph>{t("privacyPolicy.s11P1")}</Typography>
      </Box>
    </>
  );

  return (
    <Container maxWidth="md" sx={{ mt: 10, mb: 2, py: 6, backgroundColor: "#fff", px: { xs: 2, sm: 4 }, borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom textAlign="center" sx={{ fontWeight: "bold", mb: 4 }}>
        {t("privacyPolicy.title")}
      </Typography>

      <TenantLegalNotice />

      <LegalPageBody customBody={brand.legalPages?.privacy}>
        {defaultBody}
      </LegalPageBody>
    </Container>
  );
};

export default PrivacyPolicy;
